import { useEffect, useState } from 'react'
import axios from '../axios'
import '../styles/ServerSelect.css'; // Make sure to create and style this CSS file
import { Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import Title from 'antd/es/typography/Title';

function ServerSelect({ setServer }) {
    const [servers, setServers] = useState(null);
    const [selectedServer, setSelectedServer] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get("/api/discord/user")
            .then((res) => {
                setServers(res.data.guilds);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handleServerClick = (server) => {
        setSelectedServer(server);
        localStorage.setItem('selectedServer', JSON.stringify(server));
        setServer(server);
        navigate('/app/dashboard');
    };

    return (
        <div className="server-select">
            {servers ? servers.map((server) => (
                <div key={server.id} className="server-item">
                    <button
                        className={`server-button ${selectedServer === server ? 'selected' : ''}`}
                        onClick={() => handleServerClick(server)}
                    >
                        <Image src={`https://cdn.discordapp.com/icons/${server.id}/${server.icon}.png`} preview={false} />
                    </button>
                    <div className="server-name">{server.name}</div>
                </div>
            )) : <Title>Getting Server List...</Title>}
        </div>
    );
}

export default ServerSelect;
